import {
  CommandStatusType,
  ReportType,
  ThirdPartyReports,
} from 'QuoteApp/services/endpoints/GetDetails';

export const getADPFCommand = (
  reports: ReportType[] | undefined
): ReportType | undefined => {
  return reports?.find(report => report.reportName === ThirdPartyReports.Adpf);
};

export const getIsEnabled = (ADPFCommand: ReportType | undefined): boolean => {
  return !!ADPFCommand;
};

export const getIsLoading = (
  commandStatus: CommandStatusType | undefined,
  ADPFIsLoading: boolean
): boolean => {
  return commandStatus === 'is_running' || ADPFIsLoading;
};

export const getIsDisabled = (
  commandStatus: CommandStatusType | undefined
): boolean => {
  if (!commandStatus) return true;

  return (
    commandStatus === 'is_running' ||
    commandStatus === 'not_runnable' ||
    commandStatus === 'has_run'
  );
};

export const getTooltipMessage = (
  commandStatus: CommandStatusType | undefined
): string => {
  if (!commandStatus) return '';

  if (commandStatus === 'has_run') {
    return 'ADPF has already been run';
  }

  return 'Drivers license and VIN data will be populated.';
};
